/*
 * @Author: liyongliang 17837022875@163.com
 * @Date: 2022-08-30 21:23:39
 * @LastEditors: liyongliang 17837022875@163.com
 * @LastEditTime: 2022-09-21 15:48:51
 * @FilePath: /zhongheschool-web/client/components/countDown/index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import { observer } from '@/hooks/storeHooks'
import { makeAutoObservable } from 'mobx'

class countStore {
    constructor() {
        makeAutoObservable(this)
    }
    // 倒计时
    count_down = {
        day: 0,
        hour: 0,
        minute: 0,
        second: 0,
        sys_second: 0
    }

    // 修改商品详情
    changeCountDown = (e) => {
        this.count_down = e
    }
}

/**
 * endTime: 倒计时时间（秒）
 * getTimeFun: 倒计时回调 (每次倒计时都会触发)
 * endTimeFun: 结束倒计时回调
 * dayClassName 天样式
 * hourClassName 小时样式
 * minuteClassName 分钟样式
 * secondClassName 秒样式
 * showTimeChinese 是否显示中文时间（天、时、分、秒）
 * children: 自定义子元素
 * showTimeDom: 展示倒计时dom
 */
export default observer(function CountDown({
    endTime,
    getTimeFun,
    endTimeFun,
    dayClassName,
    hourClassName,
    minuteClassName,
    secondClassName,
    showTimeChinese = true,
    children,
    showTimeDom = true,
    ...props
}) {
    const [store] = useState(() => new countStore())
    const { day, hour, minute, second, sys_second } = store?.count_down
    // console.log(children)

    useEffect(() => {
        if (endTime) {
            countFun(endTime, store.changeCountDown)
        }

        return () => {
            timer ? clearInterval(timer) : ''
        }
    }, [endTime])

    // 展示时间dom
    if (!showTimeDom) {
        return null
    }

    /**
     *
     * @param {*} time 倒计时时间秒
     */
    let timer // 计时器
    function countFun(time, changeCountDown) {
        let sys_second = time // 1800s
        // 将倒计时方法抽出，立即触发第一次倒计时
        const startTimer = () => {
            //防止倒计时出现负数
            if (sys_second > 0) {
                sys_second -= 1
                let day =
                    Math.floor(sys_second / 3600 / 24) > 0
                        ? Math.floor(sys_second / 3600 / 24)
                        : 0
                let hour =
                    Math.floor((sys_second / 3600) % 24) > 0
                        ? Math.floor((sys_second / 3600) % 24)
                        : 0
                let minute =
                    Math.floor((sys_second / 60) % 60) > 0
                        ? Math.floor((sys_second / 60) % 60)
                        : 0
                let second =
                    Math.floor(sys_second % 60) > 0
                        ? Math.floor(sys_second % 60)
                        : 0
                // 把当前的时间返回出去
                if (getTimeFun) {
                    getTimeFun(day, hour, minute, second)
                }

                changeCountDown({
                    day: day,
                    hour: hour < 10 ? '0' + hour : hour,
                    minute: minute < 10 ? '0' + minute : minute,
                    second: second < 10 ? '0' + second : second,
                    sys_second: sys_second
                })
            } else {
                console.log('清楚计时器', timer)
                clearInterval(timer)
                endTimeFun && endTimeFun()
            }
            return startTimer
        }

        timer = setInterval(startTimer(), 1000)
    }

    return (
        // children 自定义子元素, 否则使用默认返回dom 支持修改样式
        <>
            {children ? (
                children
            ) : (
                <div {...props}>
                    <span className={cn(dayClassName)}>
                        {day
                            ? `${day}${showTimeChinese && '天'}`
                            : `00${showTimeChinese && '天'}`}
                    </span>
                    <span className={cn(hourClassName)}>
                        {hour && hour !== '00'
                            ? `${hour}${showTimeChinese && '小时'}`
                            : `00${showTimeChinese && '小时'}`}
                    </span>
                    <span className={cn(minuteClassName)}>
                        {minute == '0'
                            ? `00${showTimeChinese && '分'}`
                            : `${minute}${showTimeChinese && '分'}`}
                    </span>
                    <span className={cn(secondClassName)}>
                        {second == '0'
                            ? `00${showTimeChinese && '秒'}`
                            : `${second}${showTimeChinese && '秒'}`}
                    </span>
                </div>
            )}
        </>
    )
})
